import { render, staticRenderFns } from "./confirmLoan.vue?vue&type=template&id=0b1e6f08&scoped=true"
import script from "./confirmLoan.vue?vue&type=script&lang=js"
export * from "./confirmLoan.vue?vue&type=script&lang=js"
import style0 from "./confirmLoan.vue?vue&type=style&index=0&id=0b1e6f08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1e6f08",
  null
  
)

export default component.exports